import React from "react";

const RightPage8 = () => {
  return (
    <div id="Contact">
         <div className='px-6 py-12'>
            <h2 className="text-3xl font-bold text-black relative inline-block">
        Contact
        {/* Underline */}
        <span className="block w-10 h-1 bg-blue-400 mt-2"></span>
      </h2>
        </div>
    <div className="max-w-6xl mx-auto px-4 py-12">
       
        
      <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-8 grid md:grid-cols-2 gap-8">
        
        {/* Left Side */}
        <div className="space-y-6">
          <div>
            <h4 className="flex items-center space-x-2">
              <span className="bg-blue-100 p-2 rounded-full">📍</span>
              <span className="font-semibold">Address</span>
            </h4>
            <p className="text-gray-600">I-8 Islamabad</p>
          </div>

          <div>
            <h4 className="flex items-center space-x-2">
              <span className="bg-blue-100 p-2 rounded-full">📞</span>
              <span className="font-semibold">Call Us</span>
            </h4>
            <p className="text-gray-600">0316-00498-70</p>
          </div>

          <div>
            <h4 className="flex items-center space-x-2">
              <span className="bg-blue-100 p-2 rounded-full">📧</span>
              <span className="font-semibold">Email Us</span>
            </h4>
            <p className="text-gray-600">talalhaidermushtaq@gmail.com</p>
          </div>

          <iframe
            src="https://www.google.com/maps/embed?..."
            title="Company Location Map"
            className="w-full h-64 border-0 rounded"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Right Side - Form */}
        <form className="space-y-4">
          <div className="grid md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="Your Name"
              className="border border-gray-300 p-3 rounded w-full"
            />
            <input
              type="email"
              placeholder="Your Email"
              className="border border-gray-300 p-3 rounded w-full"
            />
          </div>
          <input
            type="text"
            placeholder="Subject"
            className="border border-gray-300 p-3 rounded w-full"
          />
          <textarea
            placeholder="Message"
            rows="12"
            className="border border-gray-300 p-3 rounded w-full"
          ></textarea>
          <button
            type="submit"
            className="bg-blue-500 text-white px-8 py-3 rounded-full hover:bg-blue-600 transition"
          >
            Send Message
          </button>
        </form>

      </div>
    </div>
    </div>
  );
};

export default RightPage8;

